(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook"] && !Shopify.designMode) return;
  try {
     
  class LmLookBook extends HTMLElement {
    constructor () {
      super()

      this.injectVendorScripts()
      this.querySelectorAll('.lumin-lookbook-point-list-item').forEach((elem) => {
        this.handleTooltip(elem)
      })
    } 
    
    async injectVendorScripts () {
      if (!window.FloatingUICore) {
        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/core@1.6.0')
        document.head.appendChild(script) 
      }
      if (!window.FloatingUIDOM) {
        await new Promise(r => setTimeout(r, 500))

        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/dom@1.6.1')
        document.head.appendChild(script)
      }
    }

    handleTooltip(elem) {
      const btn = elem.querySelector('button')
      const tooltip = elem.querySelector('.lm-tooltip')

      function update() {
        window.FloatingUIDOM.computePosition(btn, tooltip, {
          middleware: [
            window.FloatingUIDOM.offset(0),
            window.FloatingUIDOM.autoPlacement()
          ],
        }).then(({x, y}) => {
          Object.assign(tooltip.style, {
            left: `${x}px`,
            top: `${y}px`,
          })
        })
      }

      function showTooltip() {
        tooltip.classList.add('show')
        update()
      }
      
      function hideTooltip() {
        tooltip.classList.remove('show')
        tooltip.classList.add('hiding')
        setTimeout(() => {
          tooltip.classList.remove('hiding')
        }, 200);
      }
      
      if (window.matchMedia("(pointer: coarse)").matches) {
        [
          ['mouseenter', showTooltip],
          ['mouseleave', hideTooltip],
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      } else {
        [
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      }
    }
  }
  customElements.define('lumin-lookbook', LmLookBook)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skeldev-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const dataNode = root.querySelector('[data-review-data]');
      const grid = root.querySelector('[data-review-grid]');
      const empty = root.querySelector('[data-review-empty]');
      const summary = root.querySelector('[data-review-summary]');
      const toolbar = root.querySelector('[data-review-toolbar]');
      const resultsLine = root.querySelector('[data-results-line]');
      const loadWrap = root.querySelector('[data-load-wrap]');
      const loadButton = root.querySelector('[data-load-more]');
      const sortSelect = root.querySelector('[data-review-sort]');
      const ratingSelect = root.querySelector('[data-review-rating]');
      const timeSelect = root.querySelector('[data-review-time]');
      const dialog = root.querySelector('[data-review-dialog]');
      const pageSize = Math.max(3, Number(root.dataset.pageSize) || 9);
      let visibleLimit = pageSize;

      const labels = {
        cm: root.dataset.cmLabel || 'cm',
        month: root.dataset.monthLabel || 'month',
        months: root.dataset.monthsLabel || 'months',
        verified: root.dataset.verifiedLabel || 'Verified purchase',
        result: root.dataset.resultLabel || 'result',
        results: root.dataset.resultsLabel || 'results'
      };

      // Older reviews are embedded in the historical JSON block above.
      // Later approved reviews are loaded from the Shopify product metafield.
      const historicalNode = root.querySelector('[data-historical-review-data]');
      const parseReviewArray = (node) => {
        try {
          let parsed = JSON.parse(node?.textContent || '[]');
          if (typeof parsed === 'string') parsed = JSON.parse(parsed);
          if (Array.isArray(parsed)) return parsed;
          if (parsed && Array.isArray(parsed.reviews)) return parsed.reviews;
        } catch (error) {
          // Invalid or empty review JSON contributes no reviews.
        }
        return [];
      };
      const historicalReviews = parseReviewArray(historicalNode);
      // A historical record can be verified when its individual purchase is confirmed.
      // Shopify metafield reviews use the same record-level verification requirement.
      const liveReviews = parseReviewArray(dataNode);
      const source = [...historicalReviews, ...liveReviews];

      const isPublished = (review) => {
        if (!review || typeof review !== 'object') return false;
        if ('approved' in review) {
          return review.approved === true || review.approved === 1 || String(review.approved).toLowerCase() === 'true';
        }
        if ('status' in review) {
          return ['approved', 'published'].includes(String(review.status).toLowerCase());
        }
        // Some imported datasets contain published reviews without a moderation field.
        return true;
      };

      const hasVerifiedPurchase = (review) => {
        const flag = review.verified_purchase;
        return flag === true || flag === 1 || String(flag).toLowerCase() === 'true';
      };

      const reviews = source
        .filter(isPublished)
        .map((review, index) => ({
          id: String(review.id ?? `review-${index}`),
          name: String(review.name || '').trim().slice(0, 60),
          stars: Math.min(5, Math.max(1, Number(review.stars) || 1)),
          growth: Math.min(100, Math.max(0, Number(review.growth_cm) || 0)),
          months: Math.min(120, Math.max(1, Number(review.months) || 1)),
          verified: hasVerifiedPurchase(review),
          date: String(review.created_at || '')
        }))
        .filter((review) => review.name);

            const starElement = (rating, label) => {
        const element = document.createElement('span');
        element.className = 'sk-reviews__stars';
        element.style.setProperty('--rating', String(rating));
        element.setAttribute('role', 'img');
        element.setAttribute('aria-label', `${rating} out of 5 stars${label ? ` from ${label}` : ''}`);
        return element;
      };

      const createCard = (review) => {
        const card = document.createElement('article');
        card.className = 'sk-review-card';

        const top = document.createElement('div');
        top.className = 'sk-review-card__top';

        const name = document.createElement('h3');
        name.className = 'sk-review-card__name';
        name.textContent = review.name;
        top.append(name, starElement(review.stars, review.name));

        const result = document.createElement('p');
        result.className = 'sk-review-card__result';
        result.textContent = `${review.growth} ${labels.cm} in ${review.months} ${review.months === 1 ? labels.month : labels.months}`;

        const bottom = document.createElement('div');
        bottom.className = 'sk-review-card__bottom';

        if (review.verified) {
          const badge = document.createElement('span');
          badge.className = 'sk-review-card__badge';
          badge.textContent = `✓ ${labels.verified}`;
          bottom.append(badge);
        } else {
          bottom.append(document.createElement('span'));
        }

        card.append(top, result, bottom);
        return card;
      };

      const renderSummary = () => {
        if (!reviews.length) return;
        const average = reviews.reduce((sum, review) => sum + review.stars, 0) / reviews.length;
        root.querySelector('[data-average-rating]').textContent = average.toFixed(1);
        const averageStars = root.querySelector('[data-average-stars]');
        averageStars.style.setProperty('--rating', average.toFixed(2));
        averageStars.setAttribute('aria-label', `${average.toFixed(1)} out of 5 stars`);
        root.querySelector('[data-total-reviews]').textContent = String(reviews.length);

        const distribution = root.querySelector('[data-rating-distribution]');
        distribution.replaceChildren();

        for (let rating = 5; rating >= 1; rating -= 1) {
          const count = reviews.filter((review) => Math.round(review.stars) === rating).length;
          const percent = reviews.length ? (count / reviews.length) * 100 : 0;
          const row = document.createElement('div');
          row.className = 'sk-reviews__distribution-row';

          const number = document.createElement('span');
          number.textContent = String(rating);
          const track = document.createElement('span');
          track.className = 'sk-reviews__distribution-track';
          const fill = document.createElement('span');
          fill.className = 'sk-reviews__distribution-fill';
          fill.style.width = `${percent}%`;
          track.append(fill);
          const total = document.createElement('span');
          total.textContent = String(count);
          row.append(number, track, total);
          distribution.append(row);
        }

        summary.hidden = false;
        toolbar.hidden = false;
      };

      const filteredReviews = () => {
        const rating = ratingSelect.value;
        const timeframe = timeSelect.value;
        const filtered = reviews.filter((review) => {
          const matchesRating = rating === 'all' || Math.round(review.stars) === Number(rating);
          const matchesTime = timeframe === 'all' || (timeframe === '4plus' ? review.months >= 4 : review.months === Number(timeframe));
          return matchesRating && matchesTime;
        });

        return filtered.sort((a, b) => {
          if (sortSelect.value === 'rating') return b.stars - a.stars || b.growth - a.growth;
          if (sortSelect.value === 'growth') return b.growth - a.growth || a.months - b.months;
          if (sortSelect.value === 'rate') return (b.growth / b.months) - (a.growth / a.months);
          return new Date(b.date || 0).getTime() - new Date(a.date || 0).getTime();
        });
      };

      const render = () => {
        const filtered = filteredReviews();
        const visible = filtered.slice(0, visibleLimit);
        grid.replaceChildren(...visible.map(createCard));
        root.querySelector('[data-visible-count]').textContent = String(filtered.length);
        root.querySelector('[data-result-word]').textContent = filtered.length === 1 ? labels.result : labels.results;
        resultsLine.hidden = reviews.length === 0;
        empty.hidden = filtered.length !== 0;
        empty.style.display = filtered.length === 0 ? 'grid' : '';
        root.querySelector('[data-review-empty-heading]').textContent = reviews.length
          ? root.dataset.emptyHeading : root.dataset.noReviewsHeading;
        root.querySelector('[data-review-empty-text]').textContent = reviews.length
          ? root.dataset.emptyLabel : root.dataset.noReviewsText;
        loadWrap.hidden = visible.length >= filtered.length;
        loadWrap.style.display = visible.length < filtered.length ? 'flex' : '';
      };

      [sortSelect, ratingSelect, timeSelect].forEach((select) => {
        select.addEventListener('change', () => {
          visibleLimit = pageSize;
          render();
        });
      });

      loadButton.addEventListener('click', () => {
        visibleLimit += pageSize;
        render();
      });

      root.querySelectorAll('[data-review-open]').forEach((button) => {
        button.addEventListener('click', () => dialog.showModal());
      });

      root.querySelector('[data-review-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });

      const form = root.querySelector('.sk-reviews__form');
      form?.addEventListener('submit', () => {
        const data = new FormData(form);
        const body = root.querySelector('[data-review-body]');
        if (!body) return;
        body.value = [
          `Review name: ${data.get('contact[reviewer_name]') || ''}`,
          `Stars: ${data.get('contact[stars]') || ''}/5`,
          `Growth reported: ${data.get('contact[growth_cm]') || '0'} cm`,
          `Timeframe: ${data.get('contact[timeframe_months]') || '0'} months`,
          `Product: ${data.get('contact[product]') || ''}`
        ].join('\n');
      });

      renderSummary();
      render();

      const message = root.querySelector('[data-form-message]');
      if (message) {
        dialog.showModal();
        requestAnimationFrame(() => message.focus());
      }
    };

    document.querySelectorAll('[data-sk-reviews]').forEach(initialize);
    // The theme editor replaces section HTML when its settings change.
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-sk-reviews]').forEach(initialize);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
